export type TaskDiscoveryItem = {
  name: string;
  showByDefault: boolean;
  hardRequirements: {
    kids?: boolean;
    partner?: boolean;
    pets?: boolean;
    homeowner?: boolean;
    renter?: boolean;
    businessOwner?: boolean;
  };
  softRequirements: {
    "mental-load"?: boolean;
    travel?: boolean;
    "save-money"?: boolean;
    maintenance?: boolean;
    fun?: boolean;
    health?: boolean;
  };
};

export type UserProfile = {
  roles: {
    parent?: boolean;
    partner?: boolean;
    petOwner?: boolean;
    homeowner?: boolean;
    renter?: boolean;
    businessOwner?: boolean;
  };
  goals: {
    "mental-load"?: boolean;
    travel?: boolean;
    "save-money"?: boolean;
    maintenance?: boolean;
    fun?: boolean;
    health?: boolean;
  };
};

export const TASK_DISCOVERY_DATA: TaskDiscoveryItem[] = [
  {
    name: "Create a calendar for keeping track of school activities",
    showByDefault: false,
    hardRequirements: { kids: true },
    softRequirements: { "mental-load": true },
  },
  {
    name: "Find in-network pediatricians",
    showByDefault: false,
    hardRequirements: { kids: true },
    softRequirements: { health: true },
  },
  {
    name: "Schedule grocery delivery or meal kits",
    showByDefault: true,
    hardRequirements: {},
    softRequirements: { "mental-load": true },
  },
  {
    name: "Make reservations to a new restaurant for date night",
    showByDefault: false,
    hardRequirements: { partner: true },
    softRequirements: {},
  },
  {
    name: "Keep a running list of thoughtful surprise gifts",
    showByDefault: false,
    hardRequirements: { partner: true },
    softRequirements: { fun: true },
  },
  {
    name: "Make reservations for a team dinner",
    showByDefault: false,
    hardRequirements: { businessOwner: true },
    softRequirements: {},
  },
  {
    name: "Send flowers to a client",
    showByDefault: false,
    hardRequirements: { businessOwner: true },
    softRequirements: {},
  },
  {
    name: "Get quotes to re-finish the floors",
    showByDefault: false,
    hardRequirements: { homeowner: true },
    softRequirements: {},
  },
  {
    name: "Research the best dog supplements",
    showByDefault: false,
    hardRequirements: { pets: true },
    softRequirements: {},
  },
  {
    name: "Schedule annual vet check-ups and vaccinations",
    showByDefault: false,
    hardRequirements: { pets: true },
    softRequirements: {},
  },
  {
    name: "Create a weekly meal plan and order groceries",
    showByDefault: true,
    hardRequirements: {},
    softRequirements: { "mental-load": true },
  },
  {
    name: "Find reputable swim lessons",
    showByDefault: false,
    hardRequirements: { kids: true },
    softRequirements: {},
  },
  {
    name: "Audit and negotiate monthly bills",
    showByDefault: true,
    hardRequirements: {},
    softRequirements: { "save-money": true },
  },
  {
    name: "Book a handyman to wall-mount a large TV",
    showByDefault: true,
    hardRequirements: {},
    softRequirements: { maintenance: true },
  },
  {
    name: "Research new interesting local events to check out",
    showByDefault: true,
    hardRequirements: {},
    softRequirements: { fun: true },
  },
  {
    name: "Create a vacation packing list",
    showByDefault: false,
    hardRequirements: {},
    softRequirements: { travel: true },
  },
  {
    name: "Compare and book airport transport options",
    showByDefault: false,
    hardRequirements: {},
    softRequirements: { travel: true },
  },
  {
    name: "Find local in-network specialists or providers",
    showByDefault: true,
    hardRequirements: {},
    softRequirements: { health: true },
  },
  {
    name: "Book a mobile car detailer",
    showByDefault: true,
    hardRequirements: {},
    softRequirements: { maintenance: true },
  },
  {
    name: "Schedule recurring house cleaners or laundry pick-up",
    showByDefault: true,
    hardRequirements: {},
    softRequirements: { "mental-load": true },
  },
  {
    name: "Compare rates for home/auto insurance",
    showByDefault: true,
    hardRequirements: { homeowner: true, renter: true },
    softRequirements: { "save-money": true },
  },
  {
    name: "Keep a running list of gift ideas",
    showByDefault: true,
    hardRequirements: {},
    softRequirements: { "mental-load": true, fun: true },
  },
  {
    name: "Coordinate upholstery cleaning",
    showByDefault: true,
    hardRequirements: {},
    softRequirements: { maintenance: true },
  },
  {
    name: "Plan a weekend getaway",
    showByDefault: true,
    hardRequirements: {},
    softRequirements: { travel: true },
  },
  {
    name: "Research vacation restaurants and local spots",
    showByDefault: false,
    hardRequirements: {},
    softRequirements: { travel: true },
  },
  {
    name: "Track FSA-eligible expenses",
    showByDefault: false,
    hardRequirements: {},
    softRequirements: { "save-money": true, health: true },
  },
  {
    name: "Track credit card perks and reimbursements",
    showByDefault: true,
    hardRequirements: {},
    softRequirements: { "save-money": true },
  },
  {
    name: "Find a reputable pet sitter",
    showByDefault: false,
    hardRequirements: { pets: true },
    softRequirements: {},
  },
  {
    name: "Clean out my email inbox",
    showByDefault: true,
    hardRequirements: {},
    softRequirements: { "mental-load": true },
  },
  {
    name: "Find a pet friendly hotel",
    showByDefault: false,
    hardRequirements: { pets: true },
    softRequirements: { travel: true },
  },
  {
    name: "Order supplies for class party",
    showByDefault: false,
    hardRequirements: { kids: true },
    softRequirements: { "mental-load": true },
  },
  {
    name: "Put together a family calendar of school and activities",
    showByDefault: false,
    hardRequirements: { kids: true },
    softRequirements: { "mental-load": true },
  },
  {
    name: "Use annual VPS credits on qualifying eyewear",
    showByDefault: true,
    hardRequirements: {},
    softRequirements: { "save-money": true },
  },
  {
    name: "Make family gift list",
    showByDefault: false,
    hardRequirements: { partner: true },
    softRequirements: { "mental-load": true },
  },
  {
    name: "Book handyman for small house fixes",
    showByDefault: false,
    hardRequirements: {},
    softRequirements: { "mental-load": true, maintenance: true },
  },
  {
    name: "Look for lower car insurance rates",
    showByDefault: true,
    hardRequirements: {},
    softRequirements: { "save-money": true },
  },
  {
    name: "Check corporate benefits package for unused savings",
    showByDefault: true,
    hardRequirements: {},
    softRequirements: { "save-money": true },
  },
  {
    name: "Research childrens music lessons",
    showByDefault: false,
    hardRequirements: {},
    softRequirements: { "mental-load": true, fun: true },
  },
  {
    name: "Research reading lists by age/grade level",
    showByDefault: false,
    hardRequirements: { kids: true },
    softRequirements: { "mental-load": true, fun: true },
  },
  {
    name: "Make anniversary plans",
    showByDefault: false,
    hardRequirements: { partner: true },
    softRequirements: {},
  },
  {
    name: "Audit credit cards and subscriptions to look for savings",
    showByDefault: false,
    hardRequirements: {},
    softRequirements: { "save-money": true },
  },
  {
    name: 'Build a quarterly "household ops plan" (upcoming renewals, seasonal prep, major dates).',
    showByDefault: true,
    hardRequirements: { partner: true },
    softRequirements: { maintenance: true },
  },
  {
    name: "Create a concierge-style directory of all your service providers with contacts + terms.",
    showByDefault: true,
    hardRequirements: {},
    softRequirements: { "mental-load": true, maintenance: true },
  },
  {
    name: "Build a car-maintenance schedule with recommended shops + expected costs.",
    showByDefault: true,
    hardRequirements: {},
    softRequirements: { "save-money": true, maintenance: true },
  },
  {
    name: "Create a family emergency plan",
    showByDefault: false,
    hardRequirements: { kids: true, partner: true },
    softRequirements: {},
  },
  {
    name: 'Create a "sick-day kit" restock checklist.',
    showByDefault: true,
    hardRequirements: {},
    softRequirements: { maintenance: true, health: true },
  },
  {
    name: "Research home science activities",
    showByDefault: false,
    hardRequirements: { kids: true },
    softRequirements: { fun: true },
  },
  {
    name: "Schedule goodwill pickup",
    showByDefault: true,
    hardRequirements: {},
    softRequirements: { maintenance: true },
  },
  {
    name: "Find a handyman to mount a painting",
    showByDefault: false,
    hardRequirements: { homeowner: true, renter: true },
    softRequirements: { maintenance: true },
  },
  {
    name: "Call customer service to check on a refund",
    showByDefault: true,
    hardRequirements: {},
    softRequirements: { "mental-load": true, "save-money": true },
  },
  {
    name: "Recommend age-friendly audiobooks",
    showByDefault: false,
    hardRequirements: { kids: true },
    softRequirements: { fun: true },
  },
  {
    name: "Submit product-replacement claim",
    showByDefault: true,
    hardRequirements: {},
    softRequirements: { maintenance: true },
  },
  {
    name: "Find an in-network dietician",
    showByDefault: true,
    hardRequirements: {},
    softRequirements: { health: true },
  },
  {
    name: "Shop for blackout curtains",
    showByDefault: false,
    hardRequirements: { homeowner: true },
    softRequirements: { maintenance: true },
  },
  {
    name: "Find concerts in my city",
    showByDefault: false,
    hardRequirements: {},
    softRequirements: { fun: true },
  },
  {
    name: "Recommend a dog poop scooping service",
    showByDefault: false,
    hardRequirements: { pets: true },
    softRequirements: { maintenance: true },
  },
  {
    name: "Schedule allergy shot appointments",
    showByDefault: false,
    hardRequirements: {},
    softRequirements: { health: true },
  },
  {
    name: "Help me find new bath towels",
    showByDefault: true,
    hardRequirements: {},
    softRequirements: { maintenance: true },
  },
  {
    name: "Find out how to get TSA/Global Entry",
    showByDefault: false,
    hardRequirements: {},
    softRequirements: { travel: true },
  },
  {
    name: "Find sensory toys for the children",
    showByDefault: false,
    hardRequirements: { kids: true },
    softRequirements: { fun: true },
  },
  {
    name: "Place Instacart grocery order",
    showByDefault: true,
    hardRequirements: {},
    softRequirements: { "mental-load": true },
  },
  {
    name: "Book a termite service",
    showByDefault: false,
    hardRequirements: { homeowner: true },
    softRequirements: { maintenance: true },
  },
  {
    name: "Create a photo book",
    showByDefault: true,
    hardRequirements: {},
    softRequirements: { "mental-load": true, fun: true },
  },
];

export function filterTasksByProfile(
  profile: UserProfile,
  randomWeight: number = 0.3,
): TaskDiscoveryItem[] {
  const eligibleTasks = TASK_DISCOVERY_DATA.filter((task) => {
    if (!task.showByDefault) {
      const hardReqKeys = Object.keys(
        task.hardRequirements,
      ) as (keyof TaskDiscoveryItem["hardRequirements"])[];
      if (hardReqKeys.length === 0) return false;

      const meetsAllHardRequirements = hardReqKeys.every((key) => {
        const roleKey = {
          kids: "parent",
          partner: "partner",
          pets: "petOwner",
          homeowner: "homeowner",
          renter: "renter",
          businessOwner: "businessOwner",
        }[key] as keyof UserProfile["roles"];

        return task.hardRequirements[key] && profile.roles[roleKey];
      });

      if (!meetsAllHardRequirements) return false;
    }

    return true;
  });

  const scored = eligibleTasks.map((task) => {
    let matchScore = 0;

    const softReqKeys = Object.keys(
      task.softRequirements,
    ) as (keyof TaskDiscoveryItem["softRequirements"])[];
    softReqKeys.forEach((key) => {
      if (task.softRequirements[key] && profile.goals[key]) {
        matchScore++;
      }
    });

    const hardReqKeys = Object.keys(
      task.hardRequirements,
    ) as (keyof TaskDiscoveryItem["hardRequirements"])[];
    hardReqKeys.forEach((key) => {
      const roleKey = {
        kids: "parent",
        partner: "partner",
        pets: "petOwner",
        homeowner: "homeowner",
        renter: "renter",
        businessOwner: "businessOwner",
      }[key] as keyof UserProfile["roles"];

      if (task.hardRequirements[key] && profile.roles[roleKey]) {
        matchScore += 2;
      }
    });

    const randomComponent = Math.random() * randomWeight * 10;
    const finalScore = matchScore + randomComponent;

    return { task, score: finalScore };
  });

  scored.sort((a, b) => b.score - a.score);

  return scored.map((item) => item.task);
}

export function getRandomTasks(
  tasks: TaskDiscoveryItem[],
  count: number = 8,
  increaseRandomness: boolean = false,
): TaskDiscoveryItem[] {
  if (increaseRandomness) {
    const shuffled = [...tasks].sort(() => Math.random() - 0.5);
    return shuffled.slice(0, count);
  }

  return tasks.slice(0, count);
}
